<template>
  <span>
    <!-- <VueApexCharts type="line" height="400" :options="chartOptions" :series="series"></VueApexCharts> -->
    <VueApexCharts type="bar" height="400" :options="chartOptions" :series="series"></VueApexCharts>
  </span>
</template>
  
<script>
// Bar chart for "Active Users" card.
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    VueApexCharts,
  },
  props: {
    barChartData: {
      type: Object, default: {
        labels: [],
        datasets: [],
      }
    },
    title: { type: String, default: "Title" },
    isLoaded: { type: Boolean, default: false }
  },
  data() {
    return {
      series: [{
        name: 'Number of Alumni',
        data: [672, 706, 600, 233, 120, 20]
      },
      ],
      chartOptions: {
        chart: {
          type: 'bar',
          height: 450,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '45%',
            endingShape: 'rounded'
          },
        },
        colors: ['#1BC6F5'],//['#1BC6F5'],
        dataLabels: {
          enabled: true
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        // plotOptions: {
        //   bar: {
        //     borderRadius: 10,
        //     dataLabels: {
        //       position: 'top', // top, center, bottom
        //     },
        //   }
        // },
        // dataLabels: {
        //   enabled: true,
        //   formatter: function (val) {
        //     return val + "%";
        //   },
        //   offsetY: -20,
        //   style: {
        //     fontSize: '12px',
        //     colors: ["#304758"]
        //   }
        // },
        
        // dataLabels: {
        //   enabled: true,
        //   formatter: function (val) {
        //     return val + "%";
        //   },
        //   offsetY: -20,
        //   style: {
        //     fontSize: '12px',
        //     colors: ["#304758"]
        //   }
        // },
        xaxis: {
          labels: {
            rotate: 0,
          //   style: {
          //   fontSize: '6px',
          //   colors: ["#304758"]
          // },
          },
          categories: [[
            'Civil Servant/','Employee',' in a','government',' organization '], 
            ['Staff/Employee',' in a State-','Enterprise',' Agency'],
            ['Staff/Employee',' in a private','company'], 
            ['Your own',' business','/family','business'],
             ['Employee in',' an international',' organization'], 'Other'],
        },
        yaxis: {
          title: {
            text: 'Number of alumni'
          }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val
            }
          }
        }
      },

    };
  },
  methods: {
  },
};
</script>